"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JOBTITLE_ES = exports.JOBTITLE_EN = exports.JOBTITLE = void 0;
exports.JOBTITLE = [
    {
        label: 'Analista',
        value: 'analyst',
    },
    {
        label: 'Assistente',
        value: 'assistant',
    },
    {
        label: 'Buscando Realocação',
        value: 'unemployed',
    },
    {
        label: 'CEO ou Presidente',
        value: 'president',
    },
    {
        label: 'Coordenador',
        value: 'coordinator',
    },
    {
        label: 'Consultor',
        value: 'consultant',
    },
    {
        label: 'Diretor ou C-Level',
        value: 'director',
    },
    {
        label: 'Dono, Proprietário ou Empresário',
        value: 'owner',
    },
    {
        label: 'Estagiário',
        value: 'internal',
    },
    {
        label: 'Engenheiro',
        value: 'engineer',
    },
    {
        label: 'Estudante',
        value: 'student',
    },
    {
        label: 'Freelancer',
        value: 'freelancer',
    },
    {
        label: 'Gerente',
        value: 'manager',
    },
    {
        label: 'Investidor',
        value: 'investor',
    },
    {
        label: 'Mentor',
        value: 'mentor',
    },
    {
        label: 'Profissional Autônomo',
        value: 'self_employed',
    },
    {
        label: 'Supervisor',
        value: 'supervisor',
    },
];
exports.JOBTITLE_EN = [
    {
        label: 'Analyst',
        value: 'analyst',
    },
    {
        label: 'Assistant',
        value: 'assistant',
    },
    {
        label: 'Unemployed',
        value: 'unemployed',
    },
    {
        label: 'CEO or President',
        value: 'president',
    },
    {
        label: 'Coordinator',
        value: 'coordinator',
    },
    {
        label: 'Consultant',
        value: 'consultant',
    },
    {
        label: 'Director or C-Level',
        value: 'director',
    },
    {
        label: 'Owner, Owner or Entrepreneur',
        value: 'owner',
    },
    {
        label: 'Intern',
        value: 'internal',
    },
    {
        label: 'Engineer',
        value: 'engineer',
    },
    {
        label: 'Student',
        value: 'student',
    },
    {
        label: 'Freelancer',
        value: 'freelancer',
    },
    {
        label: 'Manager',
        value: 'manager',
    },
    {
        label: 'Investor',
        value: 'investor',
    },
    {
        label: 'Mentor',
        value: 'mentor',
    },
    {
        label: 'Self-employed',
        value: 'self_employed',
    },
    {
        label: 'Supervisor',
        value: 'supervisor',
    },
];
exports.JOBTITLE_ES = [
    {
        label: 'Analista',
        value: 'analyst',
    },
    {
        label: 'Asistente',
        value: 'assistant',
    },
    {
        label: 'Buscando reubicación',
        value: 'unemployed',
    },
    {
        label: 'CEO o Presidente',
        value: 'president',
    },
    {
        label: 'Coordinador',
        value: 'coordinator',
    },
    {
        label: 'Consultor',
        value: 'consultant',
    },
    {
        label: 'Director o nivel C',
        value: 'director',
    },
    {
        label: 'Propietario, propietario o empresario',
        value: 'owner',
    },
    {
        label: 'Interno',
        value: 'internal',
    },
    {
        label: 'Ingeniero',
        value: 'engineer',
    },
    {
        label: 'Estudiante',
        value: 'student',
    },
    {
        label: 'Persona de libre dedicación',
        value: 'freelancer',
    },
    {
        label: 'Gerente',
        value: 'manager',
    },
    {
        label: 'Inversor',
        value: 'investor',
    },
    {
        label: 'Mentor',
        value: 'mentor',
    },
    {
        label: 'Profesional autónomo',
        value: 'self_employed',
    },
    {
        label: 'Supervisor',
        value: 'supervisor',
    },
];
//# sourceMappingURL=jobtitle.js.map